/**
 * Generate a unique question ID
 * Uses crypto.randomUUID() if available, otherwise falls back to a random string
 */
export const generateQuestionId = (): string => {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return (crypto as any).randomUUID();
  }
  // Fallback: generate a random string
  return `question-${Date.now()}-${Math.random().toString(36).substring(2, 11)}`;
};
